import { Check } from "lucide-react";
import { EXTERIOR_ITEMS, IMAGES, INTERIOR_ITEMS } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

const Panel = ({ image, imageAlt, label, title, items, note, testId }) => (
  <article className="border border-white/10 bg-surface" data-testid={testId}>
    <div className="relative h-52 overflow-hidden sm:h-60">
      <img src={image} alt={imageAlt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
      <span className="absolute left-4 top-4 bg-obsidian/85 px-3 py-1.5 font-mono text-[10px] font-semibold uppercase tracking-[0.25em] text-blue-400 backdrop-blur-sm">
        {label}
      </span>
    </div>
    <div className="p-6 sm:p-9">
      <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-white sm:text-3xl">{title}</h3>
      <ul className="mt-6 grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-2">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-2.5 text-sm leading-snug text-slate-300">
            <Check size={15} strokeWidth={2.6} className="mt-0.5 shrink-0 text-blue-500" aria-hidden="true" />
            {item}
          </li>
        ))}
      </ul>
      {note && (
        <p className="mt-7 border-l-2 border-blue-600/60 bg-white/5 px-4 py-3 text-xs leading-relaxed text-slate-400" data-testid={`${testId}-disclaimer`}>
          {note}
        </p>
      )}
    </div>
  </article>
);

const Services = () => (
  <section id="services" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="services-section">
    <SectionHeading
      index="01"
      eyebrow="What's Included"
      title="One Complete Detail. Inside and Out."
      sub="Every standard service is a full interior and exterior detail — no confusing packages, no upsells you didn't ask for."
    />
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8">
      <Reveal y={36}>
        <Panel
          image={IMAGES.interior}
          imageAlt="Detailer vacuuming the interior of a vehicle"
          label="Interior"
          title="Interior Detailing"
          items={INTERIOR_ITEMS}
          note="Some stains, odors, pet hair, excessive dirt, or heavily neglected interiors may require additional time or pricing."
          testId="interior-panel"
        />
      </Reveal>
      <Reveal y={36} delay={0.12}>
        <Panel
          image={IMAGES.exterior}
          imageAlt="Hand washing the exterior of a vehicle with foam"
          label="Exterior"
          title="Exterior Detailing"
          items={EXTERIOR_ITEMS}
          testId="exterior-panel"
        />
      </Reveal>
    </div>
  </section>
);

export default Services;
